"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const SpinnerBars_1 = require("../SpinnerBars");
const Outline_1 = require("../Outline");
const Split_1 = require("../../3-list-item/Split");
const styles_1 = require("../../styles");
const context_1 = require("../../styles/context");
const inpClass = (0, nano_theme_1.rule)({
    ...styles_1.fonts.get('ui', 'bold', 1),
    fz: '15px',
    lh: '1.4em',
    d: 'block',
    w: '100%',
    bxz: 'border-box',
    bd: 0,
    bdrad: '4px',
    mr: 0,
    pd: 0,
    out: 0,
    bg: 'transparent',
    '&:disabled': {
        bg: 'transparent',
    },
});
const { useState, useCallback, useRef, useEffect } = React;
const noop = () => { };
const Input = (props) => {
    const { disabled, value, placeholder, onPaste, onEsc, onEnter, onSubmit, label, size, readOnly, type = 'text', waiting, center, align, ghost, right, multiline, mono, onChange, onKeyDown, } = props;
    const [focus, setFocus] = useState(false);
    const ref = useRef(null);
    const styles = (0, context_1.useStyles)();
    useEffect(() => {
        if (!ref.current)
            return;
        if (props.focus || props.select) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (ref.current) {
                        if (props.focus)
                            ref.current.focus();
                        if (props.select)
                            ref.current.select();
                    }
                });
            });
        }
    }, [ref.current]);
    const onFocus = useCallback((e) => {
        setFocus(true);
        (props.onFocus || noop)(e);
    }, [props.onFocus]);
    const onBlur = useCallback((e) => {
        setFocus(false);
        (props.onBlur || noop)(e);
    }, [props.onBlur]);
    const handleKeyDown = useCallback((e) => {
        if (!ref.current)
            return;
        if (props.isInForm && e.key === 'Enter') {
            ref.current.blur();
        }
        else if (e.key === 'Escape')
            onEsc?.(e);
        else if (e.key === 'Enter')
            (onEnter || onSubmit)?.(e);
        else
            onKeyDown?.(e);
    }, [onEsc, onEnter, onSubmit, onKeyDown, props.isInForm]);
    let rightElement = null;
    if (right) {
        rightElement = right;
    }
    else if (waiting) {
        rightElement = React.createElement(SpinnerBars_1.SpinnerBars, null);
    }
    const placeholderActive = value !== undefined && !value && !!placeholder;
    const style = {
        color: placeholderActive ? styles.g(0.6) : styles.g(0.1),
    };
    if (mono) {
        style.fontFamily = styles_1.fonts.get('mono').ff;
    }
    if (size) {
        const factor = size < 0 ? 1 : 2;
        style.fontSize = `${16 + size * factor}px`;
        if (size < 0) {
            style.fontWeight = styles_1.fonts.get('ui', 'mid', 1).fw;
        }
    }
    if (align) {
        style.textAlign = align;
    }
    else if (center) {
        style.textAlign = 'center';
    }
    const inputAttr = {
        ref: (input) => {
            ref.current = input;
            props.inp?.(input);
        },
        className: inpClass,
        style,
        disabled,
        value,
        placeholder: placeholder || '',
        type,
        readOnly,
        onFocus,
        onBlur,
        onKeyDown: handleKeyDown,
        onPaste,
    };
    return (React.createElement(Outline_1.Outline, { label: label, active: focus, disabled: disabled || readOnly, size: size, center: center, ghost: ghost, onClick: () => {
            if (ref.current)
                ref.current.focus();
        } },
        React.createElement(Split_1.Split, { style: { alignItems: 'center' } },
            React.createElement(multiline ? 'textarea' : 'input', {
                ...inputAttr,
                onChange: onChange ? (e) => onChange(e.target.value) : undefined,
            }),
            rightElement)));
};
exports.Input = Input;
